import { render, staticRenderFns } from "./MatchResults.vue?vue&type=template&id=6f597e02&scoped=true"
import script from "./MatchResults.vue?vue&type=script&lang=js"
export * from "./MatchResults.vue?vue&type=script&lang=js"
import style0 from "./MatchResults.vue?vue&type=style&index=0&id=6f597e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f597e02",
  null
  
)

export default component.exports